module.exports = __webpack_public_path__ + "img/3.c727f5a7.png";